import { render, staticRenderFns } from "./mark-list.vue?vue&type=template&id=aa062edc&"
import script from "./mark-list.vue?vue&type=script&lang=js&"
export * from "./mark-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports